import React, { memo } from "react";
import {
  Stack,
  Typography,
  CardContent,
  Card,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "investira.react.components";

const AtivoProventos = memo((props) => {
  const { pessoa, ativo } = props;

  if (process.env.NODE_ENV === "production") {
    return null;
  }

  if (!["ACN", "CTIM"].includes(ativo.ativo_tipo_id)) {
    return null;
  }

  return (
    <Stack flexGrow={1}>
      <Card>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack spacing={2} sx={{ py: 2 }}>
            <Stack>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
              >
                Histórico de Proventos
              </Typography>
            </Stack>
            {/* Aqui entra os ativos */}
            <Stack direction="row" spacing={1}>
              <Chip
                label={ativo.ticker || ativo.ativo}
                variant="outlined"
                color="primary"
                size="small"
              />
            </Stack>
            <Stack direction="column" sx={{ gap: 1 }}>
              <Table sx={{ minWidth: 650 }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell align="right">Data Com</TableCell>
                    <TableCell align="right">Pagamento</TableCell>
                    <TableCell align="right">Cotação</TableCell>
                    <TableCell align="right">Valor (R$)</TableCell>
                    <TableCell align="right">Yield (%)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array(11)
                    .fill()
                    .map((xValue) => {
                      return (
                        <TableRow
                          key={crypto.randomUUID()}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            Rendimento
                          </TableCell>
                          <TableCell align="right">13/09/2024</TableCell>
                          <TableCell align="right">25/09/2014</TableCell>
                          <TableCell align="right">101,31</TableCell>
                          <TableCell align="right">0,78</TableCell>
                          <TableCell align="right">0,77</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </Stack>
          </Stack>
          <Stack direction="row" justifyContent="center" sx={{ py: 1 }}>
            <Button variant={"contained"}>
              Ver todos os proventos do {ativo.ticker || ativo.ativo}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default AtivoProventos;
